import { WSList, WSTableCell, WSText } from "@wingspanhq/fe-component-library";
import React from "react";

export const SettingsList: React.FC<{ items: string[] }> = ({ items }) =>
  items.length === 0 ? (
    <WSTableCell disabled secondaryText="--" />
  ) : items.length === 1 ? (
    <WSText.ParagraphSm as="span" color="gray600">
      • {items[0]}
    </WSText.ParagraphSm>
  ) : (
    <WSList gap="XS">
      {items.map(item => (
        <WSText.ParagraphSm key={item} as="span" color="gray600">
          • {item}
        </WSText.ParagraphSm>
      ))}
    </WSList>
  );
